import React, { useMemo } from "react";
import { OFF_AIR_MESSAGES } from "./filtvConstants";

export default function FILTVOffAir({ channel }) {
    const message = useMemo(() => {
        const index = (channel?.lcn || 0) % OFF_AIR_MESSAGES.length;
        return OFF_AIR_MESSAGES[index];
    }, [channel?.lcn]);

    return (
        <div className="w-full aspect-video flex flex-col items-center justify-center bg-zinc-900 text-center px-6">
            <div className="text-4xl mb-2 opacity-70">📡</div>
            <div className="text-sm font-semibold text-zinc-300">{message}</div>
            <div className="text-xs text-zinc-500 mt-1">
                Check back soon, or explore another channel
            </div>
        </div>
    );
}
